<template>
  <v-container fluid>
    <v-row>
      <v-col
        class="pa-6"
        style="background-color: #e5f8ff; border: 1.5px solid #e8e8dd"
      >
        <v-row align="center">
          <v-col
            cols="auto"
            class="pr-0 pt-2"
          >
            <v-btn
              color="primary"
              icon
              @click="isOpen = !isOpen"
            >
              <v-icon v-if="isOpen">
                mdi-chevron-up
              </v-icon>
              <v-icon v-else>
                mdi-chevron-down
              </v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <span
              style="color: #000000; font-size: 16px; font-weight: bold"
            >PICK LIST ITEMS ({{ items.length }})</span>
          </v-col>
        </v-row>
        <v-row v-show="isOpen">
          <v-col>
            <v-row v-if="isItemOpen || items.length > 0">
              <v-col
                cols="12"
                class=""
              >
                <v-card
                  elevation="0"
                  outlined
                >
                  <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-default-footer
                    :items-per-page="-1"
                    dense
                    item-key="temp_id"
                  >
                    <template #[`item.actions`]="{ item }">
                      <v-btn
                        class="ml-1 mt-1 mb-1"
                        color="error"
                        outlined
                        small
                        @click="remove(item)"
                      >
                        REMOVE
                      </v-btn>
                    </template>
                    <template slot="body.append">
                      <tr>
                        <th />
                        <th />
                        <th />
                        <th>
                          <span
                            :style="{
                              color: isDarkMode ? '' : '#000000',
                              fontWeight: 'bold',
                              fontSize: '14px',
                              display: 'flex',
                              justifyContent: 'flex-end',
                            }"
                          >Totals:</span>
                        </th>
                        <th>
                          <span
                            :style="{
                              color: isDarkMode ? '' : '#000000',
                              fontWeight: 'bold',
                              fontSize: '14px',
                            }"
                            style="
                              color: #000000;
                              font-weight: bold;
                              font-size: 14px;
                            "
                          >{{ getTotalSupplied() }}</span>
                        </th>
                        <th />
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {},
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Location',
        value: 'inventory_tag_item.location.name',
        width: '10%',
      },
      {
        text: 'Shelf',
        value: 'inventory_tag_item.inventory_location.name',
        width: '10%',
      },
      { text: 'QR Code - Item', value: 'qr_item_full_name', width: '30%' },
      { text: 'UOM', value: 'inventory_tag_item.uom.name', width: '5%' },
      { text: 'Qty Supplied', value: 'quantity_supplied', width: '5%' },
      {
        text: 'Actions',
        value: 'actions',
        align: 'end',
        width: '25%',
      },
    ],
    isOpen: true,
    isItemOpen: false,
  }),
  computed: {
    ...mapState({
      isDarkMode: 'isDarkMode',
    }),
    ...mapGetters([]),
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    init() {},

    async open() {
      this.isOpen = true;
      this.isItemOpen = true;
    },

    close() {
      this.isItemOpen = false;
    },

    async remove(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to remove this record?',
      });
      if (!confirm) return;
      let index;
      if (item.id) {
        index = this.items.findIndex((x) => x.id === item.id);
      } else {
        // won't have this case
        index = this.items.findIndex((x) => x.temp_id === item.temp_id);
      }

      const updatedItems = this.items.map((x) => ({ ...x }));

      updatedItems.splice(index, 1);

      this.$emit('success', updatedItems);
    },

    submit() {
      //
    },

    getTotalSupplied() {
      let total = 0;
      this.items.forEach((item) => {
        if (item.quantity_supplied) total += parseInt(item.quantity_supplied, 10);
      });
      return total;
    },
  },
};
</script>
<style scoped>
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  background-color: #ffffff !important;
}

::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th
  > span {
  color: #000000;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid rgba(0, 0, 0, 0.4) !important;
}
</style>
